import { dictionary } from '../../dictionary';
import { ColumnProperty } from '../../Shared/SortableTable/SortableTable.types';
import { AutoArchiveHospital } from '../../Data/Hospital';

export const autoArchiveColumnProperties: ColumnProperty<AutoArchiveHospital>[] = [
  { displayName: dictionary.HOSPITAL_NAME_LABEL, name: 'hospitalName' },
  { displayName: dictionary.DAYS_UNTIL_ARCHIVE, name: 'daysUntilAutoArchive' },
];
